import { FC } from "react";
import "../CSS/CalendarScreenHeader.css";
import EventsMonthYearPicker from "components/elements/EventsMonthYearPicker";

interface CalendarScreenHeaderProps {
  title?: string;
  subTitle: string;
  showMonthYearSelection: boolean;
  selectedDate: Date;
  setSelectedDate: (date: string) => void;
}

const CalendarScreenHeader: FC<CalendarScreenHeaderProps> = ({
  title,
  subTitle,
  showMonthYearSelection,
  selectedDate,
  setSelectedDate,
}) => {
  return (
    <header className="calendar-screen-header-bar">
      <div className="sub-container">
        {title && <span className="title">{title}</span>}
        <span className="sub-title">{subTitle}</span></div>
      {showMonthYearSelection && <EventsMonthYearPicker
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        setCurrentDate={showMonthYearSelection}
      />}
    </header>
  );
};

export default CalendarScreenHeader;
